
/*Este componente (modal con estilos) reemplaza el window.confirm que usa prompt de react route*/
import React from "react";

const CustomPrompt = ({ message, withCleanup, headerMessage, codigoRepetidos }) => {
    return (
        <div>
            <div className="modal fade in" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
                style={{ display: "block", paddingRight: "17px" }}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{headerMessage ? headerMessage : 'Quieres salir de esta pagina?'}</h5>
                        </div>
                        <div className="modal-body">
                            {codigoRepetidos ?
                                <p>
                                    Existe(n) otro(s) registro(s) con código numéricamente igual al que se está ingresando/editando:<br />
                                    <ul>{message}</ul>
                                    ¿Desea continuar con la operación?
                                </p>
                            : 
                            <p>{message}</p>
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={() => withCleanup(true)}>Si</button>
                            <button type="button" className="btn btn-secondary" data-dismiss="modal"
                                onClick={() => withCleanup(false)}>No</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade in"></div>
        </div>
    );
}

export default CustomPrompt;


// WEBPACK FOOTER //
// ./Portico/Productos/Atlas/App/Common/Components/CustomPrompt.jsx